import { BoxProps, CSSObject } from '@chakra-ui/react';

export const wrapperProps: BoxProps = {
  h: '100%',
  minW: ['unset', null, '460px'],
  maxW: ['100vw', null, null],
  display: 'flex',
  justifyContent: 'center',
  fontFamily: 'accent',
  sx: {
    'div:first-child': {
      display: 'flex',
      flexDir: 'column',
      fontSize: 'xs',
      fontWeight: 'bold',
      alignItems: 'flex-start',
      svg: {
        boxSize: '2.5',
        mr: '1',
      },
      '.chakra-link': {
        mb: '4',
        color: 'alpha.100',
        textTransform: 'unset',
        fontSize: 10,
      },
    },
  },
  bg: 'beta.600',
  borderTop: ['2px', '2px', '0px'],
  borderColor: 'beta.400',
};

export const TextForgotPasswordSuccess: CSSObject = {
  color: 'white',
  fontSize: 'sm',
  fontStyle: 'normal',
  fontWeight: 'semibold',
  mb: '2',
  '+ a': {
    display: 'none',
  },
};

export const linkLoginProps: CSSObject = {
  fontWeight: 'bold',
  textTransform: 'uppercase',
};

export const ForgotPasswordButton: CSSObject = {
  color: 'blackAlpha.800',
  bgGradient: 'linear(to-b, alpha.300, alpha.500)',
  textShadow: 'none',
  fontWeight: 'bold',
  textTransform: 'uppercase',
  fontSize: 'xs',
};

export const Title: CSSObject = {
  color: 'alpha.300',
  fontSize: 'xs',
};
